import IntroductionDetailItem from "./IntroductionDetailItem.vue";
export default {
  name: "IntroductionDetail",
  components: {
    IntroductionDetailItem
  },
  data() {
    return {
      list: [{
        key: "infoDetail1",
        image: "info_detail_1.png",
        title: "WorkInfluencers",
        des: "WorkInfluencersDes"
      }, {
        key: "infoDetail2",
        image: "info_detail_2.png",
        title: "HighConversionRate",
        des: "HighConversionRateDes",
        flexReverse: true
      }, {
        key: "infoDetail3",
        image: "info_detail_3.png",
        title: "LinkrDataSupport",
        des: "LinkrDataSupportDes"
      }]
    };
  }
};